// components/chat/citacao.js — responder citando e encaminhar (nov/26).
//
// O resumo de uma mensagem numa linha ("Foto: legenda", "Mensagem de voz",
// o texto…). É a MESMA regra de backend/app/services/citacao.resumo: o
// servidor manda a citação pronta nas mensagens que já existem, e aqui ela
// é montada só pra bolha otimista (a resposta que acabou de sair) e pra
// barra "Respondendo a" — mudou num, muda no outro.

const ROTULOS = {
  IMAGE: 'Foto',
  VIDEO: 'Vídeo',
  AUDIO: 'Áudio',
  PTT: 'Mensagem de voz',
  STICKER: 'Figurinha',
  DOCUMENT: 'Documento',
};

// O que o webhook e o envio gravam em `content` quando a mídia veio sem
// legenda — não é legenda.
const SEM_LEGENDA = new Set([
  'Imagem recebida', 'Vídeo recebido', 'Áudio recebido', 'Figurinha', 'Mensagem de voz',
]);
const PREFIXOS_SEM_LEGENDA = ['Mídia enviada:', 'Documento:', 'Arquivo enviado:'];

const tipoDe = (msg) => String(msg?.message_type || 'TEXT').toUpperCase();

export function legenda(msg) {
  const texto = String(msg?.content || '').trim();
  if (!texto || SEM_LEGENDA.has(texto) || PREFIXOS_SEM_LEGENDA.some((p) => texto.startsWith(p))) return null;
  return texto;
}

function nomeDoDocumento(msg) {
  const texto = String(msg?.content || '').trim();
  return texto.startsWith('Documento:') ? texto.slice('Documento:'.length).trim() || null : null;
}

export function textoDoCartao(contatos) {
  if (!contatos?.length) return 'Contato compartilhado';
  const nomes = contatos.map((c) => c.nome || 'Contato');
  if (nomes.length === 1) return `Contato compartilhado: ${nomes[0]}`;
  return `${nomes.length} contatos compartilhados: ${nomes.slice(0, 4).join(', ')}${nomes.length > 4 ? '…' : ''}`;
}

export function resumo(msg, limite = 160) {
  const tipo = tipoDe(msg);
  let frase;
  if (msg?.contatos?.length) {
    frase = textoDoCartao(msg.contatos);
  } else if (tipo === 'TEMPLATE' || String(msg?.content || '').startsWith('Template: ')) {
    frase = msg?.template_render?.body || msg?.template_body || msg?.content || '';
  } else if (ROTULOS[tipo]) {
    let base = ROTULOS[tipo];
    if (tipo === 'DOCUMENT') base = nomeDoDocumento(msg) || base;
    const extra = (tipo === 'IMAGE' || tipo === 'VIDEO') ? legenda(msg) : null;
    frase = extra ? `${base}: ${extra}` : base;
  } else {
    frase = msg?.content || '';
  }
  frase = String(frase).split(/\s+/).join(' ').trim();
  return frase.length <= limite ? frase : `${frase.slice(0, limite - 1).trimEnd()}…`;
}

/** A citação no formato que o servidor manda, montada a partir da mensagem. */
export function citacaoLocal(msg, urlDaMidia) {
  if (!msg) return null;
  const tipo = tipoDe(msg);
  return {
    disponivel: true,
    id: msg.id,
    de: String(msg.direction || '').toUpperCase() === 'OUTBOUND' ? 'out' : 'in',
    tipo,
    texto: resumo(msg),
    miniatura: (tipo === 'IMAGE' || tipo === 'STICKER') && urlDaMidia ? urlDaMidia(msg) : null,
  };
}

/** Dá pra citar: a mensagem chegou ao WhatsApp (tem wamid) e já está salva. */
export function podeResponder(msg) {
  return Boolean(msg?.whatsapp_message_id) && !String(msg?.id || '').startsWith('temp-');
}

// Textos que o webhook grava quando a Cetto NÃO recebeu o conteúdo (ver
// services/encaminhar._SEM_CONTEUDO) — não há o que encaminhar.
const SEM_CONTEUDO = new Set([
  'Localização recebida', 'Contato compartilhado', 'Pedido do catálogo', 'Aviso do WhatsApp',
  'Cliente abriu a conversa', 'Reagiu a uma mensagem', '(mensagem vazia)',
  '(mensagem não exibível aqui)', '(resposta interativa)', '(botão sem rótulo)',
]);

/** Dá pra encaminhar: tem conteúdo de verdade e não é formulário. */
export function podeEncaminhar(msg) {
  if (!msg || String(msg.id || '').startsWith('temp-')) return false;
  if (msg.template_render?.formulario || msg.template_render?.formulario_resposta) return false;
  if (msg.contatos?.length) return true;
  const tipo = tipoDe(msg);
  if (ROTULOS[tipo]) return Boolean(msg.media_url);
  const texto = String(msg.content || '').trim();
  return Boolean(texto) && !SEM_CONTEUDO.has(texto) && !texto.startsWith('Respondeu o formulário');
}
